module.exports = __webpack_public_path__ + "img/gain6-min.6854521a.png";